import { useRef as h, useState as k, useEffect as T } from "react";
import { useQueryClient as v, useQuery as B } from "@tanstack/react-query";
function C(e) {
  const { data: t, error: u, status: r, isFetching: s } = e;
  return {
    status: s || r === "pending" ? "loading" : r,
    data: t,
    error: u
  };
}
const b = {
  staleTime: 1 / 0,
  refetchIntervalInBackground: !1,
  refetchOnWindowFocus: !1,
  refetchOnReconnect: !1,
  refetchOnMount: !1
}, w = {
  ...b,
  cacheTime: 0,
  keepPreviousData: !0,
  retry: !1,
  retryOnMount: !1
}, M = (e) => {
  const { resolve: t, queryKeys: u = [], id: r, options: s } = e, { onMount: n, onUnmount: Q } = s || {};
  return (i) => {
    const { query: a = {}, queryOptions: R = {} } = i, { queryKey: q = [], ...O } = R, f = v(), y = h(), [g, F] = k(!0), o = [r, ...u, a, ...q], l = B({
      ...w,
      ...O,
      queryFn: () => t(i).then((c) => y.current = c),
      queryKey: o
    }), I = C(l), D = d(a), K = d(l);
    function m(c) {
      f.setQueryData(o, c), F(!g);
    }
    function S() {
      m(y.current);
    }
    function p() {
      f.refetchQueries({ queryKey: o });
    }
    return T(() => (p(), n == null || n({
      queryRef: D,
      resultRef: K,
      refetchQuery: p
    }), Q), []), [I, m, S];
  };
};
function d(e) {
  const t = h(e);
  return t.current = e, t;
}
export {
  b as cacheForeverQueryOptions,
  M as createResourceQuery
};
//# sourceMappingURL=index.mjs.map
